import moment from "moment";
import { PrescriptionCardProps } from "./interface";
import { EyeSection } from "./components/EyeSection";
import constant from "../../../constants/constant";
import translations from "../../../constants/translations";

const Index = ({ lens, title, eyeType, isContactLens = false,arabic_title }: PrescriptionCardProps) => {
    const shouldShowRightEyeContactLens = (
    ): boolean => {
        if (!isContactLens) return true;
        return (
            !eyeType ||
            [
                constant.EYE_TYPE_CONTACT_LENS.RIGHT_EYE,
                constant.EYE_TYPE_CONTACT_LENS.BOTH_EYE,
            ].includes(eyeType?.value)
        );
    }

    const shouldShowLeftEyeContactLens = (
    ): boolean => {
        if (!isContactLens) return true;
        return (
            !eyeType ||
            [
                constant.EYE_TYPE_CONTACT_LENS.LEFT_EYE,
                constant.EYE_TYPE_CONTACT_LENS.BOTH_EYE,
            ].includes(eyeType?.value)
        );
    }

    const shouldCenterEyesRow = (): boolean => {
        if (!isContactLens) return false;
        return (
            !eyeType ||
            [
                constant.EYE_TYPE_CONTACT_LENS.RIGHT_EYE,
                constant.EYE_TYPE_CONTACT_LENS.LEFT_EYE,
            ].includes(eyeType?.value)
        )
    }

    return (
        <div className="mt-2 mb-3">
            <div className="row mt-4">
                <div className="col-12">
                    <div className="card">
                        <div>
                            <h2 className="fs-22 fw-800 text-center m-3">{title ?? "Lens"}
                               {arabic_title && <span className="arabic-only">
                                    {" "} / {arabic_title}
                                </span>}
                            </h2>
                        </div>
                        <div className="row mt-3 px-3">
                            <div className="col-md-6">
                                <div className="row">
                                    <div className="col-6">
                                        <span className="fs-16 fw-600 english-text">Customer Name</span>
                                        <span className="arabic-only">
                                            Name / {translations.Name}
                                        </span>
                                        <p className="fs-16 fw-400 secondary-color mt-1">
                                            {lens?.patient_name}
                                        </p>
                                    </div>
                                    <div className="col-6 px-0">
                                        <span className="fs-16 fw-600 english-text">Customer Number</span>
                                        <span className="arabic-only">
                                           Mobile No. / {translations.Mobile_No}
                                        </span>
                                        <p className="fs-16 fw-400 secondary-color mt-1">
                                            {lens?.patient_mobile}
                                        </p>
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-6">
                                <div className="row">
                                    <div className="col-6">
                                        <span className="fs-16 fw-600">Date </span>
                                        <span className="arabic-only">
                                            / {translations.Date}
                                        </span>
                                        <p className="fs-16 fw-400 secondary-color mt-1">
                                            {lens?.createdAt ? moment(lens.createdAt).format("DD/MM/YYYY") : ""}
                                        </p>
                                    </div>
                                    <div className="col-6 px-0">
                                        <span className="fs-16 fw-600 english-text">Store Name</span>
                                        <span className="arabic-only">
                                           Store / {translations.Store}
                                        </span>
                                        <p className="fs-16 fw-400 secondary-color mt-1">
                                            {lens?.store?.store_name}
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="top-border pb-2" style={{ borderTop: "1px solid #22222260" }}>
                            <div className={"row px-2 my-2" + (shouldCenterEyesRow() ? "d-flex justify-content-center" : "")}>
                                {shouldShowRightEyeContactLens() && <div className="col-12 col-md-6">
                                    <EyeSection side="RIGHT EYE (OD)" arabic_name={translations.Right_Eye} lens={lens} eye="r" />
                                </div>}
                                {shouldShowLeftEyeContactLens() && <div className="col-12 col-md-6 mt-4 mt-md-0 left-border">
                                    <hr className="d-block d-md-none" />
                                    <EyeSection side="LEFT EYE (OS)" arabic_name ={translations.Left_Eye} lens={lens} eye="l" />
                                </div>}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
};

export default Index;
